import type { MenuConfig } from "../../webapp/menu-system/types";
import { type OffsetClassification, type PeriodTarget, classifyOffsets, convertPeriods } from "./formula/periods";
import type { Cell } from "@package/scratchpad-utils";

export type ScratchpadCell = { key: string; src: string; error: Cell["error"] };

export type ScratchpadMenuContext = {
  cells: readonly ScratchpadCell[];
  applyEdits: (edits: readonly { key: string; src: string }[]) => void;
};

function convertItem(
  id: string,
  label: string,
  target: PeriodTarget,
  convertible: keyof Pick<OffsetClassification, "hasRelative" | "hasAbsolute">,
): MenuConfig<ScratchpadMenuContext> {
  return {
    id,
    label,
    disabled: (ctx) => {
      const kinds = classifyOffsets(ctx.cells);
      return kinds.hasError || !kinds[convertible];
    },
    action: (ctx) => () => {
      const edits = ctx.cells
        .map(({ key, src }) => ({ key, src: convertPeriods(src, target) }))
        .filter((edit, i) => edit.src !== ctx.cells[i]!.src);
      if (edits.length > 0) ctx.applyEdits(edits);
    },
  };
}

export const scratchpadContextMenu: MenuConfig<ScratchpadMenuContext>[] = [
  convertItem("convert-periods-to-absolute", "Convert all periods to absolute", "absolute", "hasRelative"),
  convertItem("convert-periods-to-relative", "Convert all periods to relative", "relative", "hasAbsolute"),
];
